// extracted by mini-css-extract-plugin
module.exports = {"arrow":"or","prevArrow":"pr","nextArrow":"qr","disabled":"rr","borderedArrow":"sr"};